import styles from "@/styles/Process.module.scss";
import classnames from "classnames";
import { useMemo } from "react";
import IconComplete from "../svgs/icon_complete.svg";
import IconExclamation from "../svgs/icon_exclamation.svg";

export default function ProcessInformation({
  complete,
  icon,
  header,
  children,
}) {
  const iconType = useMemo(() => {
    if (complete || icon === "complete") return "complete";
    return "excramation";
  }, [complete, icon]);

  return (
    <div
      className={classnames(styles.container, {
        [styles.complete]: complete,
        [styles.information]: !complete,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.header}>
          <div className={styles.icon}>
            {iconType === "complete" && <IconComplete />}
            {iconType === "excramation" && <IconExclamation />}
          </div>
          <h4 className={styles.heading}>{header}</h4>
        </div>
        {children}
      </div>
    </div>
  );
}
